import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { CHECKOUT_URL } from '../../utils/checkout';
import { pricingRows, pricingTrustItems } from '../../data/pricing';
import { pricingIncludes } from '../../data/pricingIncludes';
export function Pricing() {
  return <section id="oferta-base" className="bg-bg-secondary py-10 sm:py-14" data-id="element-173" data-mp="3gk4f0gxrbqdt">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-174" data-mp="3lh4j4mb1qj2a">
        <SectionTag icon="💰" data-id="element-175" data-mp="3piyeqg6dwwvl">Oferta Especial</SectionTag>
        <h2 className="mt-4 font-heading text-3xl font-extrabold uppercase leading-tight text-ink sm:text-4xl" data-id="element-176" data-mp="3plkngj50hife">
          ¿Cuánto vale para ti recuperar tus domingos?
        </h2>
        <p className="mt-3 text-base text-muted sm:text-lg" data-id="element-177" data-mp="3briyzl6h9pb">
          Acceso inmediato y garantía total de 7 días.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-md px-4 sm:px-6" data-id="element-178" data-mp="253mr55886w2s">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl border border-flash/25 bg-bg-primary p-6 shadow-card sm:p-7" data-id="element-179" data-mp="25466qfael8dn">
          <p className="font-heading text-xs font-bold uppercase tracking-wider text-muted" data-id="element-180" data-mp="11lqc82a7mnoo">
            🎯 EF-FLASH: Sistema Completo
          </p>
          <p className="mt-1.5 text-xs text-muted" data-id="element-181" data-mp="1u9m66z8ea1hr">11 tomos + 4 bonos, listos para llevar al patio.</p>

          <div className="mt-4 space-y-1.5" data-id="element-182" data-mp="1pahx08lh03rf">
            {pricingRows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-slate-100 py-1.5 text-sm" data-id="element-183" data-mp="1p8osozybxvml">
                <span className="text-ink/80" data-id="element-184" data-mp="1g9juxvule6bh">{row.content}</span>
                <span className="flex flex-shrink-0 items-center gap-2" data-id="element-185" data-mp="9uskp1jkx94s">
                  <span className="text-muted" data-id="element-186" data-mp="4uxy3a6u75pj">{row.value}</span>
                  <CheckIcon size={14} className="text-success" data-id="element-187" data-mp="4wr54qld3ry2" />
                </span>
              </div>)}
            <div className="flex items-center justify-between py-1.5 text-sm font-bold text-ink" data-id="element-188" data-mp="bawl6234010z">
              <span data-id="element-189" data-mp="3tgjetmd8dzoe">VALOR TOTAL</span>
              <span data-id="element-190" data-mp="3tfht8nyl9usf">253,60€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-muted" data-id="element-191" data-mp="1cguu1bwovsj">Precio hoy (92,9% de descuento):</p>
          <p className="font-heading text-5xl font-extrabold text-flash sm:text-6xl" data-id="element-192" data-mp="3jqzvkfllw3t0">17,99€</p>
          <p className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-yellow px-3 py-1 text-xs font-bold text-navy sm:text-sm" data-id="element-193" data-mp="3ohg9e0tc9rfw">
            ⏰ Precio de lanzamiento — subirá pronto
          </p>

          <ul className="mt-4 space-y-1.5 text-left text-xs text-ink/80 sm:text-sm" data-id="element-194" data-mp="3erdj48dlqrl9">
            {pricingIncludes.map(item => <li key={item} className="flex items-start gap-2" data-id="element-195" data-mp="30sx2nppxtmpx">
                <CheckIcon size={14} className="mt-0.5 flex-shrink-0 text-success" data-id="element-196" data-mp="35qp4pckaqp7u" />
                <span data-id="element-197" data-mp="35srupwlg8ick">{item}</span>
              </li>)}
          </ul>

          <div className="mt-6" data-id="element-198" data-mp="2m79eltgm5y1s">
            <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-xl bg-orange px-8 py-4 font-heading text-base font-bold uppercase tracking-wide text-white shadow-card transition-all duration-200 hover:bg-orange-hover active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-orange focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary sm:text-lg" data-id="element-199" data-mp="2h6bz5omzni3z">
              Quiero EF-FLASH por 17,99€
            </a>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-200" data-mp="3esj3qyjalagc">
            {pricingTrustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-201" data-mp="3nuimbv9ygmle">
                <item.icon size={12} data-id="element-202" data-mp="3nsfx3dgmmxhq" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}